import { TGetSecureInformationRequestListResponse } from '@commenda/types';
import { SWRFetcher } from '@commenda/utils';
import { RecurringUserTaskStatus } from '@prisma/client';
import useSWR, { KeyedMutator } from 'swr';

function useSecureInformationRequests(filters?: {
  companyId?: number;
  corporationId?: number;
  status?: RecurringUserTaskStatus;
  agentFirmId?: string;
}) {
  const query = new URLSearchParams();

  if (filters?.companyId) query.set('companyId', filters.companyId.toString());
  if (filters?.corporationId)
    query.set('corporationId', filters.corporationId.toString());
  if (filters?.status) query.set('status', filters.status);
  if (filters?.agentFirmId) query.set('agentFirmId', filters.agentFirmId);

  const URL = `secureInformationRequest/list?${query.toString()}`;

  const {
    data,
    error,
    mutate,
  }: {
    data?: TGetSecureInformationRequestListResponse;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    URL,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}

export { useSecureInformationRequests };
